import $ from 'jquery';

class Partners {
  constructor() {
    this.partner = $('.js-partner-inner');

    $(document).ready(() => {
      this.link();
    });
  }

  link() {
    this.partner.on('click', e => {
      const partner = $(e.currentTarget);
      const href = partner.attr('href');

      if (href.substr(0) === '#') {
        e.preventDefault();
      }
    });
  }
}

export default new Partners();



// WEBPACK FOOTER //
// ./src/scripts/modules/partners.js